<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row match-height" cdkDropListGroup>
      <div class="col-12" *ngIf="months && _authenticationService.hasCapability('show_widget_year_working_days')">
        <div class="card">
          <div class="px-2 pt-2 d-flex align-items-center justify-content-between">
            <h4 class="mb-0">{{ "WORKING_DAYS" | translate }} {{ totalWorkingDaysInAYear }}</h4>
            <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
              <select id="years" [(ngModel)]="selectedYear" (change)="calcuteYearWorkingDays()" class="form-control pr-3">
                <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
              </select>
            </label>
          </div>
          <div class="card-body" ngClass.sm="pb-0">
            <div class="row">
              <div class="col-lg-1 col-4 d-flex flex-column align-items-center mb-md-1 mb-0" ngClass.sm="mb-1 pb-05" *ngFor="let month of months">
                <p class="mb-0 text-primary" ngClass.sm="mb-05">{{ month.name | titlecase }}</p>
                <p class="mb-0 workingDays">{{ month.workingDays }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngFor="let column of [column_1, column_2, column_3]; let i = index"
        class="col-xl-4 col-md-6 col-12 list-container"
        [id]="'column_' + (i + 1)"
        cdkDropList
        [cdkDropListData]="column"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container *ngFor="let widget of widgets">
          <ng-container *ngIf="column.includes(widget)">
            <ng-container [ngSwitch]="widget">
              <ng-container *ngIf="column.includes(widget) && _authenticationService.currentUserSubject.value?.type === 'Dipendente'">
                <app-summary-absences *ngSwitchCase="'app_summary_absences'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-summary-absences>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('show_menu_structure_cost') && column.includes(widget)">
                <app-cost-standby *ngSwitchCase="'app_cost_standby'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-cost-standby>
              </ng-container>
              <ng-container *ngIf="column.includes(widget)">
                <app-my-task *ngSwitchCase="'app_my_tasks'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-my-task>
              </ng-container>
              <ng-container *ngIf="column.includes(widget)">
                <app-my-documents *ngSwitchCase="'app_my_documents'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-my-documents>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('show_candidate_list') && column.includes(widget)">
                <app-widget-last-candidate *ngSwitchCase="'app_widget_last_candidate'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-widget-last-candidate>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_customers_requests_list') && column.includes(widget)">
                <app-last-requests *ngSwitchCase="'app_last_requests'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-last-requests>
              </ng-container>
              <ng-container *ngIf="column.includes(widget) && _utilsService.moduleIsActive('ticket')">
                <app-my-tickets *ngSwitchCase="'app_my_tickets'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-my-tickets>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_ticket_list') && column.includes(widget)">
                <app-support-request-assigned-to-me class="widget" cdkDrag *ngSwitchCase="'app_support_request_assigned_to_me'" [style.order]="order[widget]" [cdkDragDisabled]="!_utilsService.isDesktop"></app-support-request-assigned-to-me>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('show_menu_bargaining_list') && column.includes(widget)">
                <app-widget-last-bargaining *ngSwitchCase="'app_widget_last_bargaining'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-widget-last-bargaining>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_request_suitable_candidate_list') && column.includes(widget)">
                <app-last-proposed-candidate *ngSwitchCase="'app_last_proposed_candidate'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-last-proposed-candidate>
              </ng-container>
              <ng-container *ngIf="column.includes(widget)">
                <app-report-unlock-status *ngSwitchCase="'app_report_unlock_status'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-report-unlock-status>
              </ng-container>
              <ng-container *ngIf="column.includes(widget) && _authenticationService.currentUserSubject.value?.type === 'Dipendente'">
                <app-my-refunds *ngSwitchCase="'app_my_refunds'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-my-refunds>
              </ng-container>
              <ng-container *ngIf="column.includes(widget) && _utilsService.moduleIsActive('assets')">
                <app-my-assets *ngSwitchCase="'app_my_assets'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-my-assets>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_future_employees') && column.includes(widget)">
                <app-widget-future-employees *ngSwitchCase="'app_widget_future_employees'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-widget-future-employees>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_resigned_employees') && column.includes(widget)">
                <app-resigned-future-employees
                  *ngSwitchCase="'app_resigned_future_employees'"
                  class="widget"
                  [style.order]="order[widget]"
                  cdkDrag
                  [cdkDragDisabled]="!_utilsService.isDesktop"
                ></app-resigned-future-employees>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('show_widget_simulation_costs') && column.includes(widget)">
                <app-simulation-costs *ngSwitchCase="'app_simulation_costs'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-simulation-costs>
              </ng-container>
              <ng-container *ngIf="_authenticationService.hasCapability('view_others_absences') && column.includes(widget)">
                <app-absences-to-work *ngSwitchCase="'app_absences_to_work'" class="widget" [style.order]="order[widget]" cdkDrag [cdkDragDisabled]="!_utilsService.isDesktop"></app-absences-to-work>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
